import styled from 'styled-components';

export default function DisabledBox() {
  return (
    <LevelBox>
      {['여유', '보통', '혼잡', '만차'].map(label => (
        <Level key={label}>{label}</Level>
      ))}
    </LevelBox>
  );
}

const LevelBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 8px;
  height: 48px;
  border-radius: 16px;
  width: 100%;
  border: 1px solid #f1f1f1;
  background: #f2f2f5;
  padding: 4px;
`;

const Level = styled.div`
  padding: 9px 16px;
  width: 100%;
  border-radius: 12px;
  background: transparent;
  color: #bbb;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.375px;
  text-align: center;
  opacity: 0.7;
`;
